import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import backgroundImage from "../../components/assets/hero-bg.jpg"; // Background image // Worms image (place it in assets folder)
import poultryImage from "../../components/assets/misez_product/poultry.png";
import fishImage from "../../components/assets/misez_product/aquafish.png";
import exoticFeed from "../../components/assets/misez_product/exotic.png";
import organicManure from "../../components/assets/misez_product/organicmanure.png";
import misezImg from "../../components/assets/misez_product/misez.png";
// Analytics disabled
import "./products.css";

function Product() {
  return (
    <div>
    <Helmet>
      <title>Enteeon Products - Sustainable Animal Feed Solutions</title>
      <meta name="description" content="Discover Enteeon's innovative products including poultry feed, fish feed, exotic animal feed, organic manure, and chitosan derived from black soldier fly larvae for sustainable farming." />
      <meta name="keywords" content="poultry feed, fish feed, aquaculture, organic manure, exotic animal feed, chitosan, sustainable farming, Enteeon, black soldier fly" />
      <meta property="og:title" content="Enteeon Products - Sustainable Animal Feed Solutions" />
      <meta property="og:description" content="Discover Enteeon's innovative products including poultry feed, fish feed, exotic animal feed, organic manure, and chitosan derived from black soldier fly larvae for sustainable farming." />
      <meta property="og:image" content="/enteeon_logo.png" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Enteeon Products - Sustainable Animal Feed Solutions" />
      <meta name="twitter:description" content="Discover Enteeon's innovative products including poultry feed, fish feed, exotic animal feed, organic manure, and chitosan derived from black soldier fly larvae for sustainable farming." />
      <meta name="twitter:image" content="/enteeon_logo.png" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Poultry Feed",
          "description": "Boosts immunity and improves egg quality. Improved nutritional profile of eggs and meat, enhances quality of chicken eggs, improved immune system as BSF is a probiotic.",
          "brand": "Enteeon",
          "image": poultryImage,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "INR",
            "price": "Contact for pricing"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Fish Feed",
          "description": "Organic and antibiotic-free for healthier aquaculture. Higher FCR resulting in increased fish growth rates by 20%, better meat taste and food quality, antibiotic-free & naturally organic animal upbringing.",
          "brand": "Enteeon",
          "image": fishImage,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "INR",
            "price": "Contact for pricing"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Exotic Animal Feed",
          "description": "Perfect Blend of Essential Nutrients for a Balanced Diet. The perfect balance of proteins, fats, and minerals. Ideal for reptiles, birds, and exotic pets.",
          "brand": "Enteeon",
          "image": exoticFeed,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "INR",
            "price": "Contact for pricing"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Organic Manure",
          "description": "Rich in nutrients, improves soil health. Improves soil health and crop productivity, contains essential nutrients like nitrogen, potassium, and phosphorus, a natural pest deterrent.",
          "brand": "Enteeon",
          "image": organicManure,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "INR",
            "price": "Contact for pricing"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Chitosan",
          "description": "From skincare to agriculture, chitosan is a game-changer. Deep Nourishment, Locks in moisture, Leaving your skin hydrated and supple. Healing & Repair, Helps Rejuvenate damaged Skin, reducing Wrinkles, acne and dark spots.",
          "brand": "Enteeon",
          "image": misezImg,
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "INR",
            "price": "Contact for pricing"
          }
        })}
      </script>
    </Helmet>
    <section className="enteeon-products-section position-relative">
    {/* Background Image */}
    <div
      className="enteeon-products-bg"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    ></div>

    <div className="container position-relative text-center">
      {/* Title */}
      <h2 className="enteeon-products-title">
        <span className="enteeon-bold">Enteeon</span> Products.
      </h2>
    </div>
  </section>

{/* 2nd section starts here */}

  <section className="enteeon-product-section">
      <div className="container text-center">
        {/* Title */}
        <h2 className="enteeon-product-title">Our Products.</h2>

        {/* Description */}
        <p className="enteeon-product-description">
          Enteeon's goal is to process and convert bio waste using the black
          soldier fly (BSF), and it provides an inspiring and positive
          alternative to managing bio waste and urban hygiene. Enteeon's
          innovative products will meet your animal feed needs in a
          cost-effective manner. Enteeon's sustainable insects will assist
          enhance and increase aquaculture and poultry farming productivity.
        </p>

        {/* Product Categories */}
        <div className="row text-center enteeon-product-list"> 
          <div className="col-md-3 col-6">
            <h5 className="enteeon-product-heading">Poultry Feed</h5>
            <p className="enteeon-product-text">
              Boosts immunity and improves egg quality.
            </p>
          </div>
          <div className="col-md-3 col-6">
            <h5 className="enteeon-product-heading">Fish Feed</h5>
            <p className="enteeon-product-text">
              Organic and antibiotic-free for healthier aquaculture.
            </p>
          </div>
          <div className="col-md-3 col-6 mt-4 mt-md-0">
            <h5 className="enteeon-product-heading">Exotic Animal Feed</h5>
            <p className="enteeon-product-text">
              Perfect Blend of Essential Nutrients for a Balanced Diet.
            </p>
          </div>
          <div className="col-md-3 col-6 mt-4 mt-md-0">
            <h5 className="enteeon-product-heading">Organic Manure</h5>
            <p className="enteeon-product-text">
              Rich in nutrients, improves soil health.
            </p>
          </div>
        </div>
      </div>
    </section>
    {/* 2nd section ends here */}

    {/* 3rd section starts here */}
    <section className="bgwhite-feed-section container">
      <div className="row align-items-center">
        
        <div className="col-md-5 text-center">
        <h2 className="single-product-title">Poultry Feed.</h2>
          <img src={poultryImage} alt="Poultry Feed" className="bgwhite-image" />
        </div>
        <div className="col-md-7">        
          <h4 className="why-matters text-dark">Why It Matters:</h4>
          <p className="bgwhite-text">
            A healthy poultry feed demands a rich composition of proteins, carbohydrates, vitamins, and minerals.
            Enteeon's BSF larvae ensure that nutritional demands are met for maximum intake of energy for growth,
            laying eggs, and tender juicy meat. When the nutritional diet criteria are not met, birds are vulnerable to
            diseases and weak bones, leading to poor health and an inability to produce healthy eggs or raise their younglings.
          </p>
          <h4 className="benefits text-dark">Benefits:</h4>
          <ul className="bgwhite-list">
            <li>Improved nutritional profile of eggs and meat</li>
            <li>Improves meat taste / Delicious meat</li>
            <li>Enhanced quality of chicken eggs</li>
            <li>Improved immune system as BSF is a probiotic</li>
          </ul>
        </div>
      </div>
    </section>
    {/* 3rd section ends here */}

    {/* bggreen section starts here */}
    {/* 3rd section starts here */}
    <section className="bggreen-feed-section">
      <div className='container'>
      <div className="row align-items-center">
        <div className="col-md-7">        
          <h4 className="why-matters">Why It Matters:</h4>
          <p className="bggreen-text">
          Fish has a high market value here in India. Commercially grown fish have to be fed effectively that comprises necessary nutrients ensuring their growth to full potential. Enteeon provides innovative organic feed through environment friendly technology to fulfill aquaculture’s feed demands.
          </p>
          <h4 className="benefits">Benefits:</h4>
          <ul className="bggreen-list">
            <li>Higher FCR resulting in increased fish growth rates by 20%</li>
            <li>Better meat taste and food quality</li>
            <li>Antibiotic-free & naturally organic animal upbringing</li>
          </ul>
        </div>
        <div className="col-md-5 text-center">
        <h2 className="single-product-title">Fish Feed.</h2>
          <img src={fishImage} alt="Fish Feed" className="bggreen-image" />
        </div>
      </div>
      </div>
    </section>
    {/* 3rd section ends here */}
    {/* bggreen section ends here */}


    {/* bg white starts here exotic feed */}
      {/* 3rd section starts here */}
      <section className="bgwhite-feed-section container">
      <div className="row align-items-center">
        
        <div className="col-md-5 text-center">
        <h2 className="single-product-title">Exotic Pet Feed.</h2>
          <img src={exoticFeed} alt="Exotic Pet Feed" className="bgwhite-image" />
        </div>
        <div className="col-md-7">        
          <h4 className="why-matters text-dark">Why It Matters:</h4>
          <p className="bgwhite-text">
          Enteeon's organic BSF Larvae is an excellent choice for exotic animal diets such as chameleons, birds, reptiles and home aquariums, to mention a few. Enteeon’s BSF larvae are packed with a perfect blend of essential nutrients like proteins, fats and minerals for a balanced diet which also contains all of the other required nutrients and components to meet the nutritional requirements of any animal.
          </p>
          <h4 className="benefits text-dark">Benefits:</h4>
          <ul className="bgwhite-list">
            <li>The perfect balance of proteins, fats, and minerals.            </li>
            <li>It is ideal for reptiles, birds, and exotic pets.</li>
            <li>Contains the required nutrients and components to meet the nutritional requirements of any animal.</li>
          </ul>
        </div>
      </div>
    </section>
    {/* 3rd section ends here */}
    {/* bg white exotic feed ends here */}


    {/* bggreen section starts here */}
    {/* 3rd section starts here */}
    <section className="bggreen-feed-section">
      <div className='container'>
      <div className="row align-items-center">
        <div className="col-md-7">        
          <h4 className="why-matters ">Why It Matters:</h4>
          <p className="bggreen-text">
          One of the byproducts of BSF larvae is a material called frass, which contains all the nutrients that plants need, including carbon, nitrogen, phosphate, and potassium. It is an entirely organic product that combines BSF byproducts and exo-skin material with all beneficial bacteria for necessary soil health. It also serves as a pest deterrent and strengthens the plant's overall immune system.</p>
          <h4 className="benefits">Benefits:</h4>
          <ul className="bggreen-list">
            <li>Improves soil health and crop productivity.</li>
            <li>Contains essential nutrients like nitrogen, potassium, and phosphorus.            </li>
            <li>A natural pest deterrent.</li>
          </ul>
        </div>
        <div className="col-md-5 text-center">
        <h2 className="single-product-title">Organic Manure.</h2>
          <img src={organicManure} alt="Organic Manure" className="bggreen-image" />
        </div>
      </div>
      </div>
    </section>
    {/* 3rd section ends here */}
    {/* bggreen section ends here */}


    {/* bg white starts here exotic feed */}
      {/* 3rd section starts here */}
      <section className="bgwhite-feed-section container">
      <div className="row align-items-center">
        
        <div className="col-md-5 text-center">
        <h2 className="single-product-title">Chitosan.</h2>
          <img src={misezImg} alt="Chitosan" className="bgwhite-image" />
        </div>
        <div className="col-md-7">        
          <h4 className="why-matters text-dark">Why It Matters:</h4>
          <p className="bgwhite-text">
          From skincare to agriculture, chitosan is a game-changer. Our sustainable extraction methods make it accessible and eco-friendly. SInce it is derived from natural sources, this bioactive compound offers unparalleled benefits for your skin.

          </p>
          <h4 className="benefits text-dark">Benefits:</h4>
          <ul className="bgwhite-list">
          <li>Cosmetics, pharmaceuticals, and agriculture.</li>
            <li>Deep Nourishment, Locks in moisture, Leaving your skin hydrated and supple.</li>
            <li>Healing & Repair, Helps Rejunated damaged Skin, reducing Wrinkles, acne and dark spots.</li>
          </ul>
        </div>
      </div>
    </section>
    {/* 3rd section ends here */}
    {/* bg white exotic feed ends here */}


  </div>
  )
}

export default Product